import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from 'src/app/shared/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private httpService: HttpService) { }

  getUserDetails(): Observable<any> {
    return this.httpService.checkEnvironment('getUserDetails', 'GET', null, null);
  }

  getHistoryOfChanges(payload): Observable<any> {
    return this.httpService.checkEnvironment('getHistoryOfChanges', 'POST', payload, null);
  }

  getshipToSplitBuckets(payload): Observable<any> {
    return this.httpService.checkEnvironment('getshipToSplitBuckets', 'POST', payload, null);
  }

  getShiptoBasicDetails(payload): Observable<any>{
    return this.httpService.checkEnvironment('getShiptoBasicDetails', 'POST', payload, null);
  }

  getStateDropDownValues(payload): Observable<any> {
    return this.httpService.checkEnvironment('getStateDropDownValues', 'POST', payload, null);
  }

  getTeamGeographySearchMap(payload): Observable<any> {
    return this.httpService.checkEnvironment('getTeamGeographySearchMap', 'POST', payload, null);
  }

  sendDeveloperErrorMail(payload): Observable<any> {
    return this.httpService.checkEnvironment('sendDeveloperErrorMail', 'POST', payload, null);
  }
  
  getCityStateInfoFromZipcode(payload): Observable<any> {
    return this.httpService.checkEnvironment('getCityStateInfoFromZipcode', 'POST', payload, null);
  }

  getAddOrViewNotes(payload): Observable<any> {
    return this.httpService.checkEnvironment('getAddOrViewNotes', 'POST', payload, null);
  }

  createAddOrViewNote(payload): Observable<any> {
    return this.httpService.checkEnvironment('createAddOrViewNote', 'POST', payload, null);
  }

  getPendingChangeRequestCount(payload): Observable<any> {
    return this.httpService.checkEnvironment('getPendingChangeRequestCount', 'POST', payload, null);
  }

  getShiptoCompEligibilityDetails(payload): Observable<any> {
    return this.httpService.checkEnvironment('getShiptoCompEligibilityDetails', 'POST', payload, null);
  }

  getChatbotResponse(payload): Observable<any> {
    return this.httpService.checkEnvironment('getChatbotResponse', 'POST', payload, null);
  }
  
}
